import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormTextArea, FormDropDownList, FormNumericTextBox, FormDropDownListFilter, FormDatePicker } from '../FormComponents';
import { getTargetProject } from '../../../data/projectData';
import { getSitesDropdown } from '../../../data/siteData';
import { getClientsDropdown } from '../../../data/clientData';
import { dropDown } from '../../../data/interfaces'

const EditProjectForm = (props: any) => {
   const [clientData, setClientData] = useState<dropDown[]>([]);
   const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([]);

   const [formState, setFormState] = useState({
      clientName: {
         text: '',
         value: 0,
      },
      description: '',
   });

   const [loading, setLoading] = useState(true);

   const projectId = props.onProjectId;

   console.log(projectId);

   useEffect(() => {
      const fetchClientData = async () => {
         const clientData = await getClientsDropdown('');
         setClientData(clientData);
         setClientDataOrig(clientData);
      };

      const fetchPlaceholderData = async () => {
         const project = await getTargetProject(projectId);
         setFormState({
            clientName: {
               text: project.client.clientName,
               value: project.client.clientId,
            },
            description: project.description,
         });
         setLoading(false);
      };

      fetchClientData();
      fetchPlaceholderData();
   }, [projectId]);

   const [editFocus, setEditFocus] = useState({
      clientName: false,
      description: false,
   });



   //Handle submits
   const handleSubmit = (event: any) => {
      // alert(JSON.stringify(formState, null, 2));
      // console.log(formState);
      props.onEditSubmit(formState, projectId)
   }

   const completeProjectHandler = () => {
      props.onCompleteProjectSubmit(projectId)
   }

   const deleteProjectHandler = () => {
      props.onProjectDeleteSubmit(projectId)
   }



   //Search filters
   const searchClientDropdown = (searchTerm: string) => {
      const fetchClientData = async (search: string) => {
         await getClientsDropdown(search)
            .then(
               (result) => {
                  setClientData(result);
               }
            );
      };

      fetchClientData(searchTerm);
   }

   return (
      loading ? <div>Loading...</div> :
         <div className='form__wrapper'>
            <div style={{ display: "flex", width: "100%" }}>
               <Form
                  onSubmit={handleSubmit}
                  render={(formRenderProps) => (
                     <FormElement style={{ padding: "1rem", width: "100%", marginBottom: "5rem" }}>
                        <fieldset className={"k-form-fieldset"}>
                           <div className='form__title__background' style={{ backgroundColor: "#c6def1" }}>
                              <div className='form__subtitle' style={{ color: "rgb(35 66 91)", border: "1px solid rgb(35 66 91)" }}>
                                 Edit project:
                              </div>
                           </div>

                           <Field
                              data={clientData}
                              originalData={clientDataOrig}
                              name={"clientName"}
                              component={FormDropDownListFilter}
                              label={"Choose a client:"}
                              setData={setClientData}
                              searchDropdown={searchClientDropdown}
                              defaultText={formState.clientName.text}
                              defaultValue={formState.clientName.value}
                              onChange={e => {
                                 setEditFocus({ ...editFocus, clientName: true });
                                 setFormState({ ...formState, clientName: { ...e.value, value: parseInt(e.value.value, 10) } });
                              }}
                              style={{ color: editFocus.clientName ? 'orangered' : undefined }}
                           />

                           <Field
                              name={"description"}
                              component={FormTextArea}
                              label={"Description:"}
                              placeholder={formState.description}
                              onChange={e => {
                                 setEditFocus({ ...editFocus, description: true });
                                 setFormState({ ...formState, description: e.value });
                              }}
                              style={{ color: editFocus.description ? 'orangered' : undefined }}
                           />


                           <div style={{ display: "flex", flexDirection: "row", bottom: 0, left: 0, width: "100%", padding: "1rem 0 1rem 0", position: "relative", zIndex: "10000", backgroundColor: "white" }}>
                              <button type={"submit"} className='form__edit__button edit'>Save changes to Project</button>
                              <button onClick={completeProjectHandler} className='form__edit__button accept'>Mark Project as Completed</button>
                              <button onClick={deleteProjectHandler} className='form__edit__button reject'>Mark Project as Deleted</button>
                           </div>

                        </fieldset>
                     </FormElement>
                  )}
               />
            </div>
         </div>
   );
}

export default EditProjectForm;